module.exports = __webpack_public_path__ + "img/logo-sdis34.929608a8.png";